import styled, { css } from 'styled-components'
import { elements, sizing, spacing } from 'styles'
import { propsToCSS } from 'utils'

const propStyles = {
  default: elements.default,
  primary: elements.primary,
  secondary: elements.secondary,
  outline: elements.outline,
  destructive: elements.destructive,
}

export const Button = styled.button(
  ({ center, ...props }) => css`
    display: flex;
    justify-content: ${center ? 'center' : 'space-between'};
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    padding: 14px;
    user-select: none;
    cursor: pointer;
    height: 42px;
    white-space: nowrap;

    ${propsToCSS(props, propStyles)}
    ${sizing(props)}
    ${spacing(props)}
  `,
)
